export default "__VITE_ASSET__C41Cu329__"